import { render, staticRenderFns } from "./BusinessCategoryCard.vue?vue&type=template&id=40096745&scoped=true&"
import script from "./BusinessCategoryCard.vue?vue&type=script&lang=js&"
export * from "./BusinessCategoryCard.vue?vue&type=script&lang=js&"
import style0 from "./BusinessCategoryCard.vue?vue&type=style&index=0&id=40096745&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40096745",
  null
  
)

export default component.exports